class SwiperCarousel {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => this.initializeSwiper());
    }

    initializeSwiper() {
        // 페이지네이션 요소 생성 및 설정
        const paginationElement = document.createElement('div');
        paginationElement.className = 'swiper-pagination';

        // swiper-container 요소를 찾고, 페이지네이션 요소를 자식으로 추가
        const swiperContainer = document.querySelector('.swiper-container');
        if (swiperContainer) {
            swiperContainer.appendChild(paginationElement);
        }

        // Swiper 인스턴스를 생성하고, 페이지네이션 설정을 포함
        new Swiper('.swiper-container', {
            direction: 'vertical', // 수직 슬라이드 설정 유지
            loop: true,
            autoHeight: true, // 자동 높이 조정 활성화
            slidesPerView: 1, // 한 번에 하나의 슬라이드만 보이도록 설정
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            // 여기에 필요한 추가적인 옵션을 구성할 수 있습니다.
        });
    }
}

export default SwiperCarousel;
